import classNames from "classnames";
import { ISidebarItem } from "../../../types";
import { isNotEmptyArray } from "../../../../../shared/utils/isNotEmptyArray";
import { SidebarItemContent } from "../SidebarItemContent";
import { SidebarMenuButton } from "../../SidebarButtons/SidebarMenuButton";
import styles from "./styles.module.css";
import { StorageScope } from "../../../../../services/api/instances/storageApi/types/service_types";

export const SidebarItem = ({
  item,
  selectedId,
  onSelect,
  folderIds,
  handleOpenMenuActions,
  handleFolderClick,
  withOutActions,
  selectedIds,
  service,
  className,
}: ISidebarItem) => {
  const isFolder = isNotEmptyArray(item.children) || item.value === null;
  const isSelected =
    item.id === selectedId || (selectedIds && selectedIds?.includes(item.id));
  const isFolderOpen = folderIds?.includes(item.id);
  const handleItemClick = (e: any) => {
    e.stopPropagation();
    onSelect(e, item.id);
    if (isFolder) {
      handleFolderClick && handleFolderClick(item.id);
    }
  };
  return (
    <li
      onClick={handleItemClick}
      className={classNames(
        styles["item-wrapper"],
        !isFolderOpen && styles["sidebar-folder-close"],
        isFolderOpen && styles["sidebar-folder-open"],
        item.parentId && styles["sidebar-child"],
      )}
    >
      <SidebarItemContent
        item={item}
        isFolder={isFolder}
        isFolderOpen={isFolderOpen ?? false}
        isSelected={isSelected ?? false}
        service={service as StorageScope}
        action={
          <>
            {(!item.readOnly || service === "schemas") &&
              !(item.isReceivedObject && service === "ai_agents_extra_app") && (
                <SidebarMenuButton
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleOpenMenuActions(e, "sidebar_item_actions_menu", {
                      id: item.id,
                      value: item.name,
                      extra: isFolder ? "parent" : "child",
                      metadata: {
                        isReceivedObject: item?.isReceivedObject,
                        readonly: item?.readOnly,
                      },
                    });
                  }}
                />
              )}
          </>
        }
        withoutActions={withOutActions}
      />
      {isFolder && (
        <ul className={styles["children-list"]} data-list={"children-list"}>
          {item.children?.map((child) => (
            <SidebarItem
              key={child.id}
              item={child}
              selectedId={selectedId}
              handleOpenMenuActions={handleOpenMenuActions}
              onSelect={onSelect}
              service={service}
              selectedIds={selectedIds}
            />
          ))}
        </ul>
      )}
    </li>
  );
};
